import {
  texto,
  useLoaders,
  useTableColumnsProducto,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import {
  SearchComponente,
  GeneralTable,
  CustomAutocompleteNoForm,
} from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { IServicioDigital } from "@/shared/interfaces";
import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { CATEGORYPRODUCT } from "@/shared/interfaces/erp/inventario";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { useCategoriaProductoStore } from "@/store/erp";
import { useGetServicioDigital } from "@/shared/actions/erp/servicio_digital.actions";
interface ModalServiciosDigitalesProps {
  onChange: (e: IServicioDigital) => void;
  iconButton?: boolean;
  textButton?: string;
}

export default function ModalServiciosDigitales({
  iconButton = false,
  onChange,
  textButton = "Agregar Item",
}: ModalServiciosDigitalesProps) {
  ///* State
  const [selectCategoria, setSelectCategoria] = useState<string | undefined>(
    undefined
  );
  const [openModalProducto, setOpenModalProducto] = useState<boolean>(false);

  ///* Hooks y Store
  const { categoriaProductos, isLoadingCategoriaProducto } =
    useCategoriaProductoStore();
  const { columnsSelectServicioDigitalModal } = useTableColumnsProducto();
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const {
    globalFilter,
    pagination,
    onChangeFilter,
    searchTerm,
    setPagination,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  //FETCH
  const {
    isLoading: isLoadingServiciosDigitales,
    data: serviciosDigitalesRes,
    isRefetching: isRefetchingServiciosDigitales
  } =
    useGetServicioDigital({
      enabled: !!selectCategoria || !!searchTerm,
      page: pageIndex + 1,
      page_size: pageSize,
      //codigo: searchTerm.toUpperCase(),
      nombre: searchTerm.toUpperCase(),
      categoria_producto: selectCategoria,
      ...filterObject,
      filterByState: false
    });

  useLoaders(isLoadingServiciosDigitales);

  return (
    <>
      {iconButton ? (
        <Tooltip placement="top" title="Todos los servicios digitales">
          <IconButton onClick={() => setOpenModalProducto(true)} size="medium">
            <ManageSearchIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          variant="outlined"
          onClick={() => {
            setOpenModalProducto(true);
          }}
        >
          {textButton}
        </Button>
      )}

      {openModalProducto && (
        <ScrollableDialogProps
          open={openModalProducto}
          title="Seleccionar Servicio Digital"
          //cancelTextBtn="Cerrar"
          onCloseIcon={() => {
            setSelectCategoria("");
            setOpenModalProducto(false);
          }}
          minWidth="60%"
          contentNode={
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <SearchComponente
                  onChange={onChangeFilter}
                  value={globalFilter}
                  text="por nombre de servicio digital." />
              </Grid>
              <Grid item xs={4}>
                <CustomAutocompleteNoForm<CATEGORYPRODUCT>
                  label={texto.categoria_producto}
                  options={categoriaProductos || []}
                  valueKey="nombre"
                  defaultValue={selectCategoria || ""}
                  isLoadingData={isLoadingCategoriaProducto}
                  onChangeRawValue={(e) => {
                    if (e) {
                      return setSelectCategoria(e.codigo);
                    } else {
                      setSelectCategoria("");
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                {selectCategoria && (<GeneralTable<IServicioDigital>
                  columns={columnsSelectServicioDigitalModal}
                  data={serviciosDigitalesRes?.data.data || []}
                  isLoading={isLoadingServiciosDigitales}
                  isRefetching={isRefetchingServiciosDigitales}
                  enableGlobalFilter={false}
                  pagination={pagination}
                  onPaging={setPagination}
                  rowCount={serviciosDigitalesRes?.data?.count}
                  actionsColumnSize={120}
                  canDelete={false}
                  positionActionsColumn='first'
                  enableColumnActions={true}
                  canAdd={true}
                  canEdit={false}
                  onAdd={e => {
                    onChange(e);
                  }}
                  density="comfortable"
                  enableTopToolbar={false}

                  ///* filters - server side
                  enableSorting={false}
                  enableManualFiltering={true}
                  columnFilters={columnFilters}
                  onColumnFiltersChange={setColumnFilters}

                />)}
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  );
}
